<template>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center mx-2 text-text-primary">
      {{ $t('project.members.MemberSubscription.title') }}
      <app-button type="icon" @click="cancel">
        <app-material-icon name="close" />
      </app-button>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col>
          <i18n-t v-if="userFullNameAndMail && !multi"
                  class="text-text-secondary"
                  keypath="project.members.MemberSubscription.info"
                  tag="p"
                  scope="global"
          >
            <template #user>
              <span class="font-weight-bold">
                {{ userFullNameAndMail }}
              </span>
            </template>
            <template #subName>
              <span class="font-weight-bold">
                {{ errorData.name }}
              </span>
            </template>
          </i18n-t>
          <p v-if="multi"
             v-t="{
                path: 'project.members.MemberSubscription.infoMulti',
                plural: errorData.nbUsers,
                args: { nbUsers: errorData.nbUsers, subName: errorData.name },
              }"
             class="text-text-secondary"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="errorData && errorData.yearlyPrice" cols="12" md="6">
          <AppCard hover
                   class="card-option h-100 text-text-secondary"
                   :class="{'card-option--selected': selectedOption === options.yearlyLicense}"
                   @click="selectedOption = options.yearlyLicense"
          >
            {{$t('project.members.MemberSubscription.annualSub', {price: errorData.yearlyPrice})}}
          </AppCard>
        </v-col>
        <v-col v-if="errorData && errorData.monthlyPrice" cols="12" md="6">
          <AppCard hover
                   class="card-option h-100 text-text-secondary"
                   :class="{'card-option--selected': selectedOption === options.monthlyLicense}"
                   @click="selectedOption = options.monthlyLicense"
          >
            <template v-if="errorData.monthlyPrice === -1">
              {{$t('project.members.MemberSubscription.freeTrial')}}
            </template>
            <template v-else>
              {{$t('project.members.MemberSubscription.monthlySub', {price: errorData.monthlyPrice})}}
            </template>
          </AppCard>
        </v-col>
        <v-col cols="12" md="6">
          <AppCard hover
                   class="card-option h-100 text-text-secondary"
                   :class="{'card-option--selected': selectedOption === options.noLicense}"
                   @click="selectedOption = options.noLicense"
          >
            {{$t('project.members.MemberSubscription.noSub')}}
          </AppCard>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="ma-2">
      <v-spacer />
      <app-button
        type="outlined"
        variant="neutral"
        @click="cancel"
      >
        {{$t('common.cancel')}}
      </app-button>
      <app-button
        :disabled="okDisabled"
        :loading="okLoading"
        @click="validate"
      >
        {{$t('common.ok')}}
      </app-button>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppCard from '@/common/AppCard.vue'
import { toast } from '@/common/utils/toast'

export default {
  name: 'MemberSubscription',
  components: { AppCard },
  props: {
    errorData: {
      type: Object,
      required: true,
    },
    memberForm: {
      type: Object,
      default: () => ({}),
    },
    okLoading: {
      type: Boolean,
      default: false,
    },
    multi: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedOption: null,
      options: {
        yearlyLicense: 1,
        monthlyLicense: 2,
        noLicense: 3,
      },
    }
  },
  computed: {
    userFullNameAndMail () {
      return `${this.memberForm.firstName} ${this.memberForm.lastName} (${this.memberForm.email})`
    },
    userFullName () {
      return `${this.memberForm.firstName} ${this.memberForm.lastName}`
    },
    okDisabled () {
      return !this.selectedOption
    },
  },
  methods: {
    cancel () {
      this.$emit('onCancel')
    },
    validate () {
      switch (this.selectedOption) {
        case 1 :
          this.$emit('onSubscriptionValidate', { confirmYearly: true })
          break
        case 2 :
          this.$emit('onSubscriptionValidate', { confirmMonthly: true })
          break
        case 3 :
          if (this.multi) {
            toast.error(this.$t('project.members.MemberSubscription.noSubErrorMulti', this.errorData.nbUsers))
          } else {
            toast.error(this.$t('project.members.MemberSubscription.noSubError', { member: this.userFullName }))
          }

          this.$emit('onSubscriptionDecline')
          break
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .card-option {
    border: 3px solid transparent;
  }
  .card-option--selected {
    border-color: rgb(var(--v-theme-primary));
  }
</style>
